import React from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Icon from 'react-fa';
import { openZenDeskWindow, openZenDeskWidget } from '../util/zendesk';

const SidebarHelpAndSettings = () => (
  <Nav className='sidebar-nav'>
    <LinkContainer to='/credentials'>
      <NavItem><Icon name='unlock-alt' fixedWidth /> Credentials</NavItem>
    </LinkContainer>
    <LinkContainer to='/admin'>
      <NavItem><Icon name='gear' fixedWidth /> Administration</NavItem>
    </LinkContainer>

    <NavItem onSelect={openZenDeskWidget}>
      <Icon name='question' fixedWidth /> Support
    </NavItem>

    <NavItem onSelect={openZenDeskWindow}>
      <Icon name='info' fixedWidth /> Documentation
    </NavItem>

    <LinkContainer to='/logout'>
      <NavItem><Icon name='sign-out' fixedWidth /> Signout</NavItem>
    </LinkContainer>
  </Nav>
);

export default SidebarHelpAndSettings;
